import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import './assets/seller/scss/style.scss';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import { persistor, store } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { setStore } from "./utils/storeAccessor";

setStore(store); 

const root = ReactDOM.createRoot(document.getElementById("root"));
// console.log("Initial Redux Store state:", store.getState());

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App /> 
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Detect if running on iOS
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

// Service Worker registration with better error handling for iOS Chrome
if ('serviceWorker' in navigator && !isIOS) {
  // Service Workers are not reliably supported on iOS, even in Chrome
  // Only register on non-iOS devices
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('Service Worker registered with scope:', registration.scope);
      })
      .catch((err) => {
        console.error('Service Worker registration failed:', err);
        // Don't block app on Service Worker failure
      });
  });
} else if (isIOS) {
  // iOS doesn't support Service Workers reliably
  console.warn('Service Workers not supported on iOS. Push notifications will be limited.');
}
